import React from 'react';
import { ClipboardList, Clock, CheckCircle, Upload } from 'lucide-react';

export const KPIGrid = ({ stats, onScrollToList }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-8">
    <button onClick={onScrollToList} className="kpi-card kpi-card-compact" data-testid="kpi-total">
      <ClipboardList className="w-5 h-5 md:w-6 md:h-6 text-[#E3000F] mb-1 md:mb-3" />
      <div className="kpi-value text-white text-xl md:text-3xl">{stats?.total_interventions || 0}</div>
      <div className="kpi-label text-[10px] md:text-xs">Totale Interventi</div>
    </button>
    <button onClick={onScrollToList} className="kpi-card kpi-card-compact" data-testid="kpi-today">
      <Clock className="w-5 h-5 md:w-6 md:h-6 text-[#FFC107] mb-1 md:mb-3" />
      <div className="kpi-value text-[#FFC107] text-xl md:text-3xl">{stats?.today_interventions || 0}</div>
      <div className="kpi-label text-[10px] md:text-xs">Oggi</div>
    </button>
    <button onClick={onScrollToList} className="kpi-card kpi-card-compact" data-testid="kpi-uploaded">
      <CheckCircle className="w-5 h-5 md:w-6 md:h-6 text-[#009246] mb-1 md:mb-3" />
      <div className="kpi-value text-[#009246] text-xl md:text-3xl">{stats?.uploaded_to_vvf || 0}</div>
      <div className="kpi-label text-[10px] md:text-xs">Caricati VVF</div>
    </button>
    <button onClick={onScrollToList} className="kpi-card kpi-card-compact" data-testid="kpi-pending">
      <Upload className="w-5 h-5 md:w-6 md:h-6 text-[#A1A1AA] mb-1 md:mb-3" />
      <div className="kpi-value text-[#A1A1AA] text-xl md:text-3xl">{stats?.pending_upload || 0}</div>
      <div className="kpi-label text-[10px] md:text-xs">Da caricare</div>
    </button>
  </div>
);
